<template>
  <div>
    <z-select
      :options="options"
      v-model="value[selectKey]"
      :popperAppendToBody="false"
      style="margin-right: 12px; width: 120px"
      v-if="selectKey"
      @change="handleSelectChange"
    ></z-select>
    <el-date-picker
      v-model="val"
      :appendToBody="true"
      :type="dateType"
      align="right"
      v-bind="dateOptions"
      range-separator="~"
      @change="handleDateChange"
      clearable
    />
    <!-- :style="{width: dateType === 'daterange' ? '280px' : '390px'}" -->
  </div>
</template>
<script>
export default {
  name: 'ZSelectDatepicker',
  props: {
    selectKey: {
      type: String,
    },
    value: {},
    options: {
      type: Array,
      default: () => [],
    },
    dateType: {
      type: String,
      default: 'datetimerange',
      validator(val) {
        return ['datetimerange', 'daterange'].includes(val)
      },
    },
    dateComponentData: {
      type: Object,
    },
  },
  data() {
    return {
      val: [],
    }
  },
  computed: {
    dateOptions() {
      const data = {
        valueFormat: 'yyyy-MM-dd',
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
      }
      if (this.dateType === 'datetimerange') {
        data.defaultTime = ['00:00:00', '23:59:59']
        data.valueFormat = 'yyyy-MM-dd HH:mm:ss'
        data.startPlaceholder = '开始时间'
        data.endPlaceholder = '结束时间'
      }
      const dateComponentData = this.dateComponentData || {}
      if (dateComponentData) {
        delete dateComponentData.type
      }
      return { ...data, ...dateComponentData }
    },
    list() {
      return this.options.map(item => {
        if (!item.keys) {
          return { ...item, keys: [item.value + 'Start', item.value + 'End'] }
        }
        return item
      })
    },
    onlyDatePicker() {
      return this.list.length === 1
    },
    selectDateKeys() {
      let keys = []
      let queryItem = this.list.find(i => this.value[this.selectKey] === i.value)
      if (this.onlyDatePicker) {
        queryItem = this.list[0]
      }
      if (queryItem) {
        keys = queryItem.keys || []
      }
      return keys
    },
  },
  watch: {
    value: {
      handler(val) {
        this.handleValue(val)
      },
      immediate: true,
    },
  },
  methods: {
    handleValue(form) {
      try {
        const selectDateKeys = this.selectDateKeys
        if (selectDateKeys.length) {
          this.val = [form[selectDateKeys[0]], form[selectDateKeys[1]]].filter(Boolean)
        } else {
          this.val = []
        }
      } catch (e) {}
    },
    handleDateChange(val) {
      const data = {}
      this.list.forEach(item => {
        ;(item.keys || []).forEach(key => {
          data[key] = ''
        })
      })
      if (val) {
        const selectDateKeys = this.selectDateKeys
        selectDateKeys.forEach((key, index) => {
          data[key] = val[index]
        })
      }
      this.$emit('input', { ...this.value, ...data })
    },
    handleSelectChange(val) {
      this.handleDateChange(this.val)
    },
  },
}
</script>
